import { publicPath } from './config/path'
__webpack_public_path__ = ((new URL(((document||{}).currentScript||{}).src||window.location)).origin) + `${publicPath}/`